<app-analysis-info-panel
  [analysis]="selectedAnalysis"
  [contextActions]="selectedAnalysis ? (contextActionsMap.get(selectedAnalysis.AnalysisID) ?? null) : null"
  [isOpen]="isInfoPanelOpen"
  [downloads]="selectedAnalysisDownloads"
  (closed)="onInfoPanelClosed()"
  (viewResultClicked)="selectedAnalysis && handleViewResult(selectedAnalysis.AnalysisID)"
  (pluginLaunched)="
    selectedAnalysis && handlePluginLaunched({ pluginId: $event, analysisId: selectedAnalysis.AnalysisID })
  "
  (downloadRequested)="
    selectedAnalysis && handleDownloadResult({ type: $event, analysisId: selectedAnalysis.AnalysisID })
  "
/>

<div class="sub-container">
  <app-table-search (filterChanged)="onFilterChanged($event)"></app-table-search>
  <app-buttons
    [isDisabled]="selectedAnalysisItems.length === 0"
    [name]="shareBtnName"
    [buttonType]="btnMatFlat"
    [buttonStyle]="
      selectedAnalysisItems.length === 0 ? btnStyleFilledSmallForPrimaryBtnDisabled : btnStyleFilledSmallForPrimaryBtn
    "
    (buttonClickEvent)="onShareClicked()"
  >
  </app-buttons>
</div>
<app-analysis-table
  [dataSource]="dataSource"
  [rowStatusOverrides]="rowStatusOverrides"
  [rowProgressMap]="rowProgressMap"
  [userRole]="userRole"
  [userCanManage]="['Admin', 'Manager'].includes(userRole)"
  [contextActionsMap]="contextActionsMap"
  [activeAnalysisId]="activeRowAnalysisId"
  [isViewResultDisabled]="isViewResultDisabledFn"
  [isDownloadResultDisabled]="isDownloadResultDisabledFn"
  [isPluginMenuDisabled]="isPluginMenuDisabledFn"
  (checkboxChanged)="handleCheckboxChange($event)"
  (rowMenuOpened)="onRowMenuOpened($event)"
  (rowMenuClosed)="onRowMenuClosed()"
  (viewResultClicked)="handleViewResult($event.analysisId)"
  (getInfoClicked)="handleGetInfoClick($event)"
  (downloadRequested)="handleDownloadResult($event)"
  (pluginLaunched)="handlePluginLaunched($event)"
  (editClicked)="handleEditClick($event)"
  (deleteClicked)="handleDeleteClick($event)"
>
</app-analysis-table>
